import React from 'react';
import { Typography, InputCopy, Box } from '@p81-common/ui';
import { useTranslation } from 'react-i18next';
import { createClasses } from './styles';
import DisassociateTenants from '../DisassociateTenants/DisassociateTenants';
import { access, hasAccess, resources } from '../../../utils/permissions';

interface TenantDetailsProps {
  company: any;
  updateDataFn?: () => void;
}

const TenantDetails = ({ company, updateDataFn }: TenantDetailsProps) => {
  const { t } = useTranslation('activity');
  const classes = createClasses();
  const { companyName, tenantUUID, tenantId } = company;

  const hasAssociationAccess = hasAccess([
    resources.CUSTOMERS_ASSOCIATION,
    access.WRITE
  ]);

  return (
    <Box>
      <Typography
        variant="h2"
        className={classes.heading}
        dangerouslySetInnerHTML={{
          __html: t('tenantDetails.TITLE', { companyName })
        }}
      />

      <Typography variant="subtitle2" className={classes.inputLabel}>
        {t('tenantDetails.SUBTITLE')}
      </Typography>

      <InputCopy
        copyText={t('tenantDetails.COPY_ID')}
        value={tenantUUID}
        className={classes.inputCopy}
      />

      {hasAssociationAccess && (
        <DisassociateTenants
          companyName={companyName}
          tenantId={tenantId}
          tenantUUID={tenantUUID}
          updateDataFn={updateDataFn || (() => {})}
        />
      )}
    </Box>
  );
};

export default TenantDetails;
